<template>
  <div class="profile-container">
    <el-card class="profile-card" shadow="never">
      <div slot="header" class="card-header">
        <h2>{{ $t("basicInfo") }}</h2>
      </div>

      <!-- 头像区域 -->
      <div class="avatar-container">
        <el-avatar
          :size="120"
          :src="user.avatarimg | avatar"
          class="user-avatar"
        >
          <i class="el-icon-camera" v-if="!user.avatarimg"></i>
        </el-avatar>

        <el-upload
          class="avatar-uploader"
          action=""
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :http-request="uploadFile"
        >
          <el-button size="small" type="primary">{{
            $t("changeAvatar")
          }}</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $t("avatarTip") }}
          </div>
        </el-upload>
      </div>

      <el-form label-width="120px" class="info-form">
        <!-- 用户名 -->
        <el-form-item :label="$t('account')">
          <div v-if="!editingFields.name" class="display-mode">
            <span>{{ user.name }}</span>
            <el-button
              type="text"
              @click="handleEdit('name')"
              style="margin-left: 10px"
              >{{ $t("edit") }}</el-button
            >
          </div>
          <div v-else class="edit-mode">
            <el-input
              v-model="tempName"
              style="width: 200px; margin-right: 10px"
              :placeholder="$t('pleaseInputUsername')"
            ></el-input>
            <el-button type="text" @click="cancelEdit('name')">{{
              $t("cancel")
            }}</el-button>
            <el-button type="primary" @click="saveEdit('name')">{{
              $t("save")
            }}</el-button>
          </div>
        </el-form-item>

        <!-- 手机 -->
        <el-form-item :label="$t('phone')">
          <span>{{ user.phone }}</span>
          <el-button
            type="text"
            @click="goToPhoneEdit"
            style="margin-left: 10px"
            >{{ $t("edit") }}</el-button
          >
        </el-form-item>

        <!-- 邮箱 -->
        <el-form-item :label="$t('email')">
          <div v-if="!editingFields.email" class="display-mode">
            <span>{{ user.email }}</span>
            <el-button
              type="text"
              @click="handleEdit('email')"
              style="margin-left: 10px"
              >{{ $t("edit") }}</el-button
            >
          </div>
          <div v-else class="edit-mode">
            <el-input
              v-model="tempEmail"
              style="width: 200px; margin-right: 10px"
              :placeholder="$t('pleaseInputEmail')"
            ></el-input>
            <el-button type="text" @click="cancelEdit('email')">{{
              $t("cancel")
            }}</el-button>
            <el-button type="primary" @click="saveEdit('email')">{{
              $t("save")
            }}</el-button>
          </div>
        </el-form-item>

        <!-- 微信号 -->
        <el-form-item :label="$t('wechat')">
          <div v-if="!editingFields.wechatnumber" class="display-mode">
            <span>{{ user.wechatnumber }}</span>
            <el-button
              type="text"
              @click="handleEdit('wechatnumber')"
              style="margin-left: 10px"
              >{{ $t("edit") }}</el-button
            >
          </div>
          <div v-else class="edit-mode">
            <el-input
              v-model="tempWechatnumber"
              style="width: 200px; margin-right: 10px"
              :placeholder="$t('pleaseInputWechat')"
            ></el-input>
            <el-button type="text" @click="cancelEdit('wechatnumber')">{{
              $t("cancel")
            }}</el-button>
            <el-button type="primary" @click="saveEdit('wechatnumber')">{{
              $t("save")
            }}</el-button>
          </div>
        </el-form-item>

        <!-- 注册时间 -->
        <el-form-item :label="$t('registerTime')">
          <span>{{ user.addTime }}</span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Profile",
  data() {
    return {
      userId: "",
      user: {},
      editingFields: {
        name: false,
        email: false,
        wechatnumber: false,
      },
      tempName: "",
      tempEmail: "",
      tempWechatnumber: "",
      loading: false,
    };
  },
  created() {
    const user = this.$cookies.get("userInfo");
    this.userId = user.userid;
    this.$get("/get_user_info", { userid: this.userId }).then((res) => {
      if (res.data.code == 1) {
        this.user = res.data.data;
      } else {
        this.$message.error(res.data.msg);
      }
    });
  },
  methods: {
    uploadFile(params) {
      const form = new FormData();
      form.append("file", params.file);
      this.$post("/upload_avatar", form, {
        headers: { "Content-type": "multipart/form-data" },
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.user.avatarimg = res.data.data;
            this.$message.success(this.$t("avatarUploadSuccess"));
            const cookiesUserInfo = this.$cookies.get("userInfo");
            if (cookiesUserInfo) {
              cookiesUserInfo.avatarimg = res.data.data;
              this.$cookies.set("userInfo", cookiesUserInfo);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleAvatarSuccess(response, file) {
      this.user.avatarimg = URL.createObjectURL(file.raw);
      this.$message.success(this.$t("avatarUploadSuccess"));
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error(this.$t("avatarFormatError"));
      }
      if (!isLt5M) {
        this.$message.error(this.$t("avatarSizeError"));
      }
      return isJPG && isLt5M;
    },

    goToPhoneEdit() {
      this.$router.push({
        path: "/about-me/phone-edit",
        query: { phone: this.user.phone },
      });
    },

    handleEdit(field) {
      this.editingFields[field] = true;
      if (field === "name") {
        this.tempName = this.user.name;
      } else if (field === "email") {
        this.tempEmail = this.user.email;
      } else if (field === "wechatnumber") {
        this.tempWechatnumber = this.user.wechatnumber;
      }
    },

    cancelEdit(field) {
      this.editingFields[field] = false;
    },

    saveEdit(field) {
      this.loading = true;
      const params = {};
      if (field === "name") {
        params.name = this.tempName;
      } else if (field === "email") {
        params.email = this.tempEmail;
      } else if (field === "wechatnumber") {
        params.wechatnumber = this.tempWechatnumber;
      }

      this.$post("/update_user_info", params)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(this.$t("saveSuccess"));
            this.user[field] =
              this[`temp${field.charAt(0).toUpperCase() + field.slice(1)}`];
            this.editingFields[field] = false;

            if (field == "name") {
              const cookiesUserInfo = this.$cookies.get("userInfo");
              if (cookiesUserInfo) {
                cookiesUserInfo.name =
                  this[`temp${field.charAt(0).toUpperCase() + field.slice(1)}`];
                this.$cookies.set("userInfo", cookiesUserInfo);
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t("saveFailed"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.profile-container {
  width: 100%;
  box-sizing: border-box;
}

.profile-container .el-card {
  border: none;
}

.profile-card {
  margin: 0 auto;
}

::v-deep .el-card__header {
  padding: 0px 16px;
}

.card-header {
  font-weight: bold;
}

.info-form {
  display: flex;
  flex-direction: column;
}

.avatar-container {
  text-align: center;
  padding: 20px 0;
}

.user-avatar {
  margin-bottom: 15px;
  border: 1px solid #eee;
}

@media (max-width: 768px) {
  .profile-card {
    max-width: 100%;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
